module.exports = __webpack_public_path__ + "media/images/payments/coinkite-dark-817c39e227c671101621b8d8a0708489.svg";